var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDurationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_250_153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#505050"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_250_153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 17.9167C9.01755 17.9167 8.09665 17.7308 7.23776 17.359C6.37873 16.9872 5.62977 16.4818 4.99089 15.8429C4.352 15.204 3.84665 14.4551 3.47484 13.596C3.10304 12.7372 2.91714 11.8163 2.91714 10.8333C2.91714 9.85042 3.10304 8.92952 3.47484 8.07063C3.84665 7.2116 4.352 6.46265 4.99089 5.82376C5.62977 5.18487 6.37873 4.67952 7.23776 4.30772C8.09665 3.93591 9.01755 3.75001 10.0005 3.75001C10.9834 3.75001 11.9043 3.93591 12.7632 4.30772C13.6222 4.67952 14.3712 5.18487 15.0101 5.82376C15.6489 6.46265 16.1543 7.2116 16.5261 8.07063C16.8979 8.92952 17.0838 9.85042 17.0838 10.8333C17.0838 11.8163 16.8979 12.7372 16.5261 13.596C16.1543 14.4551 15.6489 15.204 15.0101 15.8429C14.3712 16.4818 13.6222 16.9872 12.7632 17.359C11.9043 17.7308 10.9834 17.9167 10.0005 17.9167ZM12.478 14.1892L13.3563 13.3108L10.6255 10.5802V6.66667H9.37547V11.0865L12.478 14.1892ZM4.79526 2.40709L5.67359 3.28521L2.45234 6.50646L1.57422 5.62813L4.79526 2.40709ZM15.2057 2.40709L18.4267 5.62813L17.5486 6.50646L14.3273 3.28521L15.2057 2.40709ZM10.0005 16.6667C11.6202 16.6667 12.9973 16.0994 14.1319 14.9648C15.2665 13.8302 15.8338 12.4531 15.8338 10.8333C15.8338 9.21362 15.2665 7.83646 14.1319 6.70188C12.9973 5.5673 11.6202 5.00001 10.0005 5.00001C8.38075 5.00001 7.00359 5.5673 5.86901 6.70188C4.73443 7.83646 4.16714 9.21362 4.16714 10.8333C4.16714 12.4531 4.73443 13.8302 5.86901 14.9648C7.00359 16.0994 8.38075 16.6667 10.0005 16.6667Z",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/durationIcon.532dfa57a0a90d24ca193007eb291c36.svg";
export { ForwardRef as ReactComponent };